<template>
  <div class="age">
    <b-button v-b-modal.age-picker block class="age-input font-weight-bold" variant="light" data-test-id="AgeInput"
      >{{ age || "Choose Age" }}
    </b-button>
    <b-modal id="age-picker" ref="age-picker" hide-footer hide-header title="Choose Age">
      <b-form data-test-id="AgeForm" @reset="resetAge" @submit.prevent="submitAge">
        <div class="custom-modal-header">
          <div>Choose Age</div>
          <b-button type="reset" variant="link" data-test-id="clear-age-button">Clear</b-button>
        </div>
        <hr class="separator" />
        <b-button-group class="as-block mb-3">
          <b-button
            variant="outline-secondary"
            :pressed="unit === 'Years'"
            data-test-id="YearsButton"
            @click="setUnit('Years')"
            >Years</b-button
          >
          <b-button
            variant="outline-secondary"
            :pressed="unit === 'Months'"
            data-test-id="MonthsButton"
            @click="setUnit('Months')"
            >Months</b-button
          >
          <b-button
            variant="outline-secondary"
            :pressed="unit === 'Weeks'"
            data-test-id="WeeksButton"
            @click="setUnit('Weeks')"
            >Weeks</b-button
          >
        </b-button-group>
        <b-form-group :description="`From 1 to ${max[unit]}`">
          <b-form-input
            v-model="value"
            autofocus
            min="1"
            required
            type="number"
            :max="max[unit]"
            :placeholder="`Type ${unit}`"
            data-test-id="AgeModalInput"
          ></b-form-input>
        </b-form-group>
        <hr class="separator" />
        <b-button block type="submit" variant="danger" data-test-id="AgeSubmitButton">Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Age",

  props: {
    selectedAge: {
      default: () => {},
      type: Object,
    },
  },

  data() {
    return {
      age: "",
      max: { Years: 120, Months: 24, Weeks: 24 },
      unit: "Years",
      value: "",
    };
  },

  mounted() {
    if (this.selectedAge) {
      this.unit = this.selectedAge ? this.selectedAge.unit : "";
      this.value = this.selectedAge ? this.selectedAge.value : "";
      this.submitAge();
    }
  },

  methods: {
    resetAge() {
      this.age = "";
      this.value = "";
      this.$emit("age-updated", {});
      this.$refs["age-picker"].hide();
    },

    setUnit(unit) {
      this.unit = unit;
    },

    submitAge() {
      if (this.value) {
        this.$emit("age-updated", {
          value: parseInt(this.value, 10),
          unit: this.unit,
        });
        this.age = `${this.value} ${this.unit}`;
        this.$refs["age-picker"].hide();
      }
    },
  },
};
</script>

<style scoped>
.age {
  flex: 1;
}

.age-input {
  text-align: center;
  white-space: nowrap;
}

.as-block {
  display: flex;
}

.as-block > .btn {
  flex: 1;
}

.custom-modal-header {
  align-items: center;
  display: flex;
}

.custom-modal-header > .btn {
  margin-left: auto;
}

.separator {
  margin-left: -1rem;
  margin-right: -1rem;
}
</style>
